import React from 'react';
import PropTypes from 'prop-types';
import errorBoundary from '@ifeng-fe/errorBoundary';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination, Keyboard } from 'swiper';
import { formatImageWebpAuto } from '@ifeng-fe/public_method';
import 'swiper/css';
import Style from './index.css';

const throttle = (func, delay) => {
    let lastCall = 0;

    return (...args) => {
        const now = new Date().getTime();

        if (now - lastCall < delay) {
            return;
        }
        lastCall = now;

        return func.apply(this, args);
    };
};

const Page3 = (props) => {
    const { peopleList, peopleIndex, onChangePeopleIndex } = props;

    return (
        <div className={Style.page2}>
            <div className={Style.swiperWp}>
                <img className={Style.navigation} id="page3_prev" src="https://x0.ifengimg.com/ucms/2025_21/B251CD52F05D57B202DA73B52C91171EF3FC5865_size3_w69_h127.png" alt="" />
                <div className={Style.swiperBox}>
                    <Swiper
                        key={peopleIndex}
                        modules={[Navigation, Pagination, Keyboard]}
                        className={Style.swiper}
                        speed={1500}
                        loop={true}
                        navigation={{
                            prevEl: '#page3_prev',
                            nextEl: '#page3_next',
                        }}
                        pagination={{
                            el: `.${Style.pagination}`,
                            type: 'fraction',
                        }}
                        keyboard={{
                            enabled: true,
                        }}>
                        {peopleList[peopleIndex]?.imageList.map((image, index) => {
                            return (
                                <SwiperSlide key={index}>
                                    <div className={Style.swiperItem}>
                                        <img src={formatImageWebpAuto(image, 1193, 672)} alt="" />
                                    </div>
                                </SwiperSlide>
                            );
                        })}
                    </Swiper>
                </div>
                <img className={Style.navigation} id="page3_next" src="https://x0.ifengimg.com/ucms/2025_21/93FE47FFC16150E66207FE6DC842DDEF6171C468_size3_w68_h126.png" alt="" />

                <div className={Style.pagination} />
            </div>

            <div className={Style.peopleList}>
                {peopleList.map((people, index) => {
                    return (
                        <div key={index}>
                            <div className={`${Style.people} ${index === peopleIndex ? Style.active : ''}`} onClick={() => throttle(onChangePeopleIndex(index), 500)}>
                                {people.name}
                            </div>
                            {index < peopleList.length - 1 && <span className={Style.divider}>/</span>}
                        </div>
                    );
                })}
            </div>
        </div>
    );
};

Page3.propTypes = {
    peopleList: PropTypes.array,
    peopleIndex: PropTypes.number,
    onChangePeopleIndex: PropTypes.func,
};

export default errorBoundary(Page3);
